module.exports = __webpack_public_path__ + "static/media/linearregression.880549d0.png";